const cutName = (name: string, max_length: number): string => {
    if (!name) return '-'

    if (name && name.length > max_length) {
        let name_parts = name.split('')
        name_parts = name_parts.splice(0, max_length - 1)
        name_parts.push('...')
        return name_parts.join('')
    }

    return name
}

export default cutName
